// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import $ from 'jquery';  
window.jQuery = $; 
window.$ = $;

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery-ui")
require("courseware/bootstrap-treeview")
require("courseware/custom")
require("./snackbar")
require("./jquery.zoomable")

// Add any custom javascript in a separate folder via an index.js file and require it here
// https://prathamesh.tech/2019/09/24/mastering-packs-in-webpacker/

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import 'bootstrap'
import '../stylesheets/application'

import 'jstree'
require("trix")
require("@rails/actiontext")

// require("imperavi/article-editor.min.js")
// require("imperavi/plugins/counter/counter.min.js")
// require("imperavi/plugins/variable/variable.min.js")
// require("imperavi/plugins/reorder/reorder.min.js")
// require("imperavi/plugins/icons/icons.min.js")
// require("imperavi/plugins/specialchars/specialchars.min.js")
// require("imperavi/plugins/selector/selector.min.js")


